import React, { useMemo } from 'react';
import {
  arrayOf, number, func,
} from 'prop-types';
import { Flex, Typography, Circle } from '@atoms';
import { common } from '@constants';

const AvailabilityDays = ({
  onDayClick, selectedWeekDays,
}) => {
  const memoizedDays = useMemo(() => common.weekDays.map(({ name, id }) => (
    <Circle
      key={id}
      diameter={32}
      onClick={onDayClick(id)}
      backgroundColor={selectedWeekDays.includes(id) ? 'strawberry' : 'stone'}
    >
      <Flex justifyCenter itemsCenter>
        <Typography size="md" weight="bold" color="white">
          {name}
        </Typography>
      </Flex>
    </Circle>
  )), [selectedWeekDays]);

  return (
    <Flex justifyBetween>
      {memoizedDays}
    </Flex>
  );
};

AvailabilityDays.propTypes = {
  onDayClick: func.isRequired,
  selectedWeekDays: arrayOf(number).isRequired,
};

export default AvailabilityDays;
